import arrowsPosition from './arrowsPosition';
import arrowsVerticalPosition from './arrowsVerticalPosition';
import cubeType from './cubeType';
import dimensions from './dimensions';
import events from './events';
import deviceType from './deviceType';
import gallerySizeType from './gallerySizeType';
import galleryTextAlign from './galleryTextAlign.js';
import gridStyle from './gridStyle';
import cubeFitPosition from './cubeFitPosition';
import groupTypes from './groupTypes';
import imageHoverAnimations from './imageHoverAnimations';
import infoBehaviourOnHover from './infoBehaviourOnHover';
import infoType from './infoType';
import isVertical from './isVertical';
import itemClick from './itemClick';
import layout, { isLayout } from './layout';
import layoutDirection from './layoutDirection';
import loadingMode from './loadingMode';
import loadingWithColorMode from './loadingWithColorMode';
import loadMoreAmount from './loadMoreAmount';
import mobileSwipeAnimations from './mobileSwipeAnimations';
import overlayAnimations from './overlayAnimations';
import placements, { hasExternalAbovePlacement, hasExternalBelowPlacement, hasHoverPlacement, hasExternalRightPlacement, hasExternalLeftPlacement, hasExternalVerticalPlacement, hasExternalHorizontalPlacement, isExternalAbovePlacement, isExternalBelowPlacement, isHoverPlacement, isExternalRightPlacement, isExternalLeftPlacement, isExternalVerticalPlacement, isExternalHorizontalPlacement, isConstantVerticalPlacement, } from './placements';
import resizeMethods from './resizeMethods';
import scrollAnimations from './scrollAnimations';
import slideAnimations from './slideAnimations';
import scrollDirection from './scrollDirection';
import socialNetworks from './socialNetworks';
import textBoxWidthCalculationOptions from './textBoxWidthCalculationOptions';
import thumbnailsAlignment from './thumbnailsAlignment';
import thumbnailsPosition from './thumbnailsPosition';
import { URL_SIZES as urlSizes, URL_TYPES as urlTypes } from './urlTypes';
import videoPlay from './videoPlay';
import viewMode from './viewMode';
import imagePlacementAnimations from './imagePlacementAnimations';
import slideTransition from './slideTransition';
import overlayPositions from './overlayPositions';
import overlaySizeType from './overlaySizeType';
import autoSlideshowTypes from './autoSlideshowTypes';
import arrowsType from './arrowsType';
import arrowsContainerStyleType from './arrowsContainerStyleType';
import itemResolutionMode from './itemResolutionMode';
import autoSlideBehaviour from './autoSlideBehaviour';
import secondaryMediaTrigger from './secondaryMediaTrigger';
import secondaryMediaBehaviour from './secondaryMediaBehaviour';
export default {
    arrowsPosition: arrowsPosition,
    itemResolutionMode: itemResolutionMode,
    arrowsVerticalPosition: arrowsVerticalPosition,
    cubeType: cubeType,
    dimensions: dimensions,
    events: events,
    deviceType: deviceType,
    gallerySizeType: gallerySizeType,
    galleryTextAlign: galleryTextAlign,
    gridStyle: gridStyle,
    cubeFitPosition: cubeFitPosition,
    groupTypes: groupTypes,
    imageHoverAnimations: imageHoverAnimations,
    infoBehaviourOnHover: infoBehaviourOnHover,
    infoType: infoType,
    isVertical: isVertical,
    itemClick: itemClick,
    layout: layout,
    isLayout: isLayout,
    layoutDirection: layoutDirection,
    loadingMode: loadingMode,
    loadingWithColorMode: loadingWithColorMode,
    loadMoreAmount: loadMoreAmount,
    mobileSwipeAnimations: mobileSwipeAnimations,
    overlayAnimations: overlayAnimations,
    placements: placements,
    hasExternalAbovePlacement: hasExternalAbovePlacement,
    hasExternalBelowPlacement: hasExternalBelowPlacement,
    hasHoverPlacement: hasHoverPlacement,
    hasExternalRightPlacement: hasExternalRightPlacement,
    hasExternalLeftPlacement: hasExternalLeftPlacement,
    hasExternalVerticalPlacement: hasExternalVerticalPlacement,
    hasExternalHorizontalPlacement: hasExternalHorizontalPlacement,
    isExternalAbovePlacement: isExternalAbovePlacement,
    isExternalBelowPlacement: isExternalBelowPlacement,
    isHoverPlacement: isHoverPlacement,
    isExternalRightPlacement: isExternalRightPlacement,
    isExternalLeftPlacement: isExternalLeftPlacement,
    isExternalVerticalPlacement: isExternalVerticalPlacement,
    isExternalHorizontalPlacement: isExternalHorizontalPlacement,
    isConstantVerticalPlacement: isConstantVerticalPlacement,
    resizeMethods: resizeMethods,
    scrollAnimations: scrollAnimations,
    slideAnimations: slideAnimations,
    scrollDirection: scrollDirection,
    socialNetworks: socialNetworks,
    textBoxWidthCalculationOptions: textBoxWidthCalculationOptions,
    thumbnailsAlignment: thumbnailsAlignment,
    thumbnailsPosition: thumbnailsPosition,
    urlSizes: urlSizes,
    urlTypes: urlTypes,
    videoPlay: videoPlay,
    viewMode: viewMode,
    imagePlacementAnimations: imagePlacementAnimations,
    slideTransition: slideTransition,
    overlayPositions: overlayPositions,
    overlaySizeType: overlaySizeType,
    autoSlideshowTypes: autoSlideshowTypes,
    arrowsType: arrowsType,
    arrowsContainerStyleType: arrowsContainerStyleType,
    autoSlideBehaviour: autoSlideBehaviour,
    secondaryMediaTrigger: secondaryMediaTrigger,
    secondaryMediaBehaviour: secondaryMediaBehaviour,
};
//# sourceMappingURL=index.js.map